import React from 'react';
import { useTranslation } from 'react-i18next';

import * as Styled from './create-task-shortcut-fallback.style';

export const CreateTaskShortcutFallback: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Styled.Container>
      <Styled.Label>
        {t('forms.user-settings.sections.shortcuts.fields.shortcuts.label')}
      </Styled.Label>

      <Styled.Description>
        {t('forms.user-settings.sections.shortcuts.unavailable.download.1')}
        <Styled.Anchor target="_blank" href="https://griply.app/download">
          {t(
            'forms.user-settings.sections.shortcuts.unavailable.download.link',
          )}
        </Styled.Anchor>
        {t('forms.user-settings.sections.shortcuts.unavailable.download.2')}
      </Styled.Description>
    </Styled.Container>
  );
};
